var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.data.routerLink ? "router-link" : "a",
    {
      ref: "card",
      tag: "component",
      class: _vm.classList,
      attrs: {
        href: _vm.data.routerLink
          ? typeof _vm.data.routerLink === "string"
            ? _vm.data.routerLink
            : _vm.data.routerLink.path
          : _vm.data.link.type + _vm.data.link.label,
        to: _vm.data.routerLink ? _vm.data.routerLink.to : null
      }
    },
    [
      _c("div", {
        staticClass: "category-card__hover",
        attrs: { "data-hovered": "true" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "category-card__inner" },
        [
          _c(
            "div",
            { staticClass: "category-card__icon-wrapper" },
            [
              _c("v-card-icon", {
                attrs: {
                  backgroundPosition: _vm.data.backgroundPosition,
                  iconName: _vm.data.iconName
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-typo", {
            staticClass: "category-card__headline",
            attrs: { variant: "h3" },
            domProps: { innerHTML: _vm._s(_vm.data.headline) }
          }),
          _vm._v(" "),
          _vm.data.link
            ? _c("v-typo", {
                staticClass: "category-card__label",
                attrs: { variant: "body-perex" },
                domProps: { innerHTML: _vm._s(_vm.data.link.label) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-typo", {
            staticClass: "category-card__label",
            attrs: { variant: "body-perex" },
            domProps: { innerHTML: _vm._s(_vm.data.perex) }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "category-card__link" },
            [
              _c("v-typo", {
                staticClass: "category-card__link-label",
                attrs: { variant: "body-perex" },
                domProps: { innerHTML: _vm._s(_vm.$t(_vm.data.cta)) }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }